<template>
    <div class="public_container payable_payment_wrap" v-loading="formLoading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                ref="payablePaymentForm"
                class="custom_mobile_form"
            >
                <template v-if="paymentType === 'payment'">
                    <van-field
                        v-model="payableDetails.basic_info.unpaid_amount"
                        name="unpaid_amount"
                        label="应付未付金额"
                        placeholder="自动带出"
                        readonly
                    >
                    </van-field>
                </template>

                <van-field
                    v-model="paymentInfoForm.payment_method_text"
                    name="pay_type_text"
                    label="支付方式"
                    placeholder="请选择"
                    readonly
                    is-link
                    @click="handleClickSelectPayType"
                >
                </van-field>
                <van-field
                    required
                    v-model="paymentInfoForm.payment_time"
                    name="payment_time"
                    label="付款时间"
                    placeholder="请选择"
                    readonly
                    is-link
                    @click="handleClickSelectPayTime"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
                <template v-if="paymentType === 'payment'">
                    <van-field
                        required
                        v-model="paymentInfoForm.payment_amount"
                        name="payment_amount"
                        label="付款金额"
                        placeholder="请输入"
                        @blur="handlePayAmountBlur(paymentInfoForm, payableDetails.basic_info.unpaid_amount)"
                    >
                    </van-field>
                </template>
                <div v-if="paymentType === 'batch_payment'">
                    <van-field v-model="paymentInfoForm.unpaid_amount" label="应付总金额" placeholder="请输入" readonly>
                        <template slot="input">
                            <span class="input_disabled">{{
                                paymentInfoForm.payableBatchPayInfo
                                    .reduce((total, item) => total + Number(item.payable_amount), 0)
                                    .toFixed(2)
                            }}</span>
                        </template>
                    </van-field>
                    <van-field v-model="paymentInfoForm.unpaid_amount" label="未付总金额" placeholder="请输入" readonly>
                        <template slot="input">
                            <span class="input_disabled">{{
                                paymentInfoForm.payableBatchPayInfo
                                    .reduce((total, item) => total + Number(item.unpaid_amount), 0)
                                    .toFixed(2)
                            }}</span>
                        </template>
                    </van-field>
                    <van-field v-model="paymentInfoForm.unpaid_amount" label="支付总金额" placeholder="请输入" readonly>
                        <template slot="input">
                            <span class="input_disabled">{{
                                paymentInfoForm.payableBatchPayInfo
                                    .reduce((total, item) => total + Number(item.payment_amount), 0)
                                    .toFixed(2)
                            }}</span>
                        </template>
                    </van-field>
                    <ul>
                        <li class="payable_list_item" v-for="(row, rowIndex) in paymentInfoForm.payableBatchPayInfo">
                            <div class="payable_list_item_top">
                                <div class="mobile_detail_head_user">
                                    <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                    <span class="ellipsis">{{ row.uid_info && row.uid_info.name }}</span>
                                </div>
                                <span>审批编号：</span>
                                <span class="link-label">{{ row.approval_number }}</span>
                                <i
                                    class="iconfont icon-shanchu1 payable_list_item_delete"
                                    @click="handleClickBatchDelete(rowIndex)"
                                ></i>
                            </div>
                            <div class="payable_list_item_content">
                                <p>
                                    应付编号：<span class="link-label">{{ row.payable_no }}</span>
                                </p>
                                <template v-if="payable_type == 'purchase'">
                                    <p>
                                        采购编号：<span class="link-label">{{
                                            row.detail && row.detail.purchase_no
                                        }}</span>
                                    </p>
                                    <p>供应商名称：{{ row.detail && row.detail.supplier_name }}</p>
                                </template>
                                <template v-else-if="payable_type == 'order_return'">
                                    <p>
                                        订单编号：<span class="link-label">{{
                                            row.detail && row.detail.order_no
                                        }}</span>
                                    </p>
                                    <p>
                                        客户公司名称：<span>{{ row.detail && row.detail.customer_company_name }}</span>
                                    </p>
                                </template>
                                <template v-else>
                                    <p>收款方：{{ row.detail && row.detail.payee_name }}</p>
                                </template>
                                <div class="payable_list_item_amount">
                                    <div>
                                        <div class="payable_list_item_amount_percent percent_bg1">
                                            应付金额：¥{{ row.payable_amount }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="payable_list_item_amount_percent percent_bg2">
                                            已付金额：¥{{ row.paid_amount }}
                                        </div>
                                        <div class="payable_list_item_amount_percent percent_bg3">
                                            未付金额：¥{{ row.unpaid_amount }}
                                        </div>
                                    </div>
                                </div>
                                <p>
                                    <van-field
                                        required
                                        v-model="row.payment_amount"
                                        name="payment_amount"
                                        label="支付金额："
                                        placeholder="请输入"
                                        label-width="5em"
                                        input-align="right"
                                        :rules="[{ required: true, message: '请输入' }]"
                                    >
                                    </van-field>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <van-field
                    v-model="paymentInfoForm.remarks"
                    name="remarks"
                    label="备注"
                    placeholder="请输入"
                    rows="4"
                    maxlength="200"
                    autosize
                    type="textarea"
                    input-align="left"
                    class="vertical_input_wrap"
                >
                </van-field>
                <van-field name="voucher" label="支付凭证" class="vertical_input_wrap">
                    <template #input>
                        <div class="upload_input_wrap">
                            <ul class="voucher_list">
                                <li :key="index" class="voucher_item" v-for="(item, index) in paymentInfoForm.voucher">
                                    <van-image :src="item" alt=""> </van-image>
                                    <i
                                        @click="paymentInfoForm.voucher.splice(index, 1)"
                                        class="iconfont icon-guanbi_dise"
                                    ></i>
                                </li>
                                <li @click="handleClickUploadFile" class="upload_img_wrap">
                                    <i class="el-icon-plus"></i>
                                </li>
                            </ul>
                            <p class="hint">请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）</p>
                        </div>
                    </template>
                </van-field>
            </van-form>
            <!-- 部分支付或全部支付后 -->
            <template v-if="payableDetails.payment_records && payableDetails.payment_records.length > 0">
                <div class="form_module_title">支付记录</div>
                <div class="paylog_wrap">
                    <ul>
                        <li v-for="row in payableDetails.payment_records">
                            <p>付款时间：{{ row.payment_time }}</p>
                            <p>
                                支付方式：{{
                                    row.payment_method
                                        ? payTypeList.find((item) => item.value == row.payment_method).name
                                        : ""
                                }}
                            </p>
                            <p>支付金额：{{ row.payment_amount }}</p>
                            <p>备注：{{ row.remarks }}</p>
                            <p>支付凭证：</p>
                            <div v-if="row.voucher && row.voucher.length">
                                <ul class="voucher_list">
                                    <li
                                        :key="index"
                                        class="voucher_item"
                                        v-for="(item, index) in row.voucher"
                                        @click="handleClickPreviewImg(index, row.voucher)"
                                    >
                                        <van-image :src="item" alt=""> </van-image>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>

        <!-- 选择支付方式 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="payTypeRadioPicker"
            :show="payTypeRadioPicker"
        >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in payTypeList"
                        class="radio_option_item"
                        @click="handleClickPayTypeOption(item)"
                        v-text="item.name"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="payTypeRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <!-- 选择时间 -->
        <van-popup
            :style="{ height: '352px' }"
            round
            position="bottom"
            v-if="showDatePopupShow"
            v-model="showDatePopupShow"
        >
            <van-datetime-picker
                v-model="currentTime"
                type="datetime"
                title="选择时间"
                @cancel="showDatePopupShow = false"
                @confirm="handleDateCalenderConfirm"
                :min-date="dateCalendarMin"
                :max-date="dateCalendarMax"
            />
        </van-popup>
    </div>
</template>

<script>
import { PayableDetail, PayableInfoByNos, PayablePaymentAdd, PayableBatchPayment } from "@/api";
import { ImagePreview } from "vant";
import { uploadImg } from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "PayablePayment",
    components: { ReturnNavBar },
    data() {
        return {
            formLoading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            payable_no: "", // 应付编号
            paymentType: "", // payment:单个付款，batch_payment：批量付款
            payable_type: "", // 采购=purcahse，订单：order_return, 否则就是自定义控件的
            payableDetails: {
                basic_info: {}, // 基础信息
                cancel_info: {},
                payee_info: {}, //收款方信息
                payment_records: [], //付款记录
            },
            paymentInfoForm: {
                payment_method: 1,
                payment_method_text: "电汇",
                payment_amount: "",
                payment_time: this.formatDate(new Date(), "datetime"),
                remarks: "",
                voucher: [],
                paylog_bill: [],
                payableBatchPayInfo: [], // 批量支付信息
            },
            payTypeRadioPicker: false,
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],
            showDatePopupShow: false,
            currentTime: "",
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            btnDisabled: false,
        };
    },
    created() {
        if (this.$route.query) {
            this.payable_no = this.$route.query.payable_no;
            this.paymentType = this.$route.query.type;
            this.payable_type = this.$route.query.payable_type;
            if (this.paymentType === "payment") {
                // 单个支付
                this.getPayableDetail();
            } else {
                // 批量支付
                this.getPayableBatchPayInfo();
            }
        }
    },
    methods: {
        // 应付详情
        getPayableDetail() {
            this.formLoading = true;
            PayableDetail({ payable_no: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.payableDetails = data;
                    if (this.payableDetails.basic_info) {
                        this.paymentInfoForm.payment_amount = this.payableDetails.basic_info.unpaid_amount;
                    }
                }
                this.formLoading = false;
            });
        },
        // 获取批量详情数据
        getPayableBatchPayInfo() {
            this.formLoading = true;
            PayableInfoByNos({ payable_nos: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    res.data.forEach((item) => {
                        item.payment_amount = item.unpaid_amount;
                    });
                    this.paymentInfoForm.payableBatchPayInfo = res.data || [];
                }
                this.formLoading = false;
            });
        },
        // 选择支付方式
        handleClickSelectPayType() {
            this.payTypeRadioPicker = true;
        },
        // 支付方式选择确认
        handleClickPayTypeOption(item) {
            this.paymentInfoForm.payment_method = item.value;
            this.paymentInfoForm.payment_method_text = item.name;
            this.payTypeRadioPicker = false;
        },
        // 删除批量支付的某一个
        handleClickBatchDelete(index) {
            this.paymentInfoForm.payableBatchPayInfo.splice(index, 1);
        },
        //格式化输入的支付金额
        handlePayAmountBlur(paymentInfoForm, unpaid_amount) {
            paymentInfoForm["payment_amount"] = paymentInfoForm["payment_amount"].replace(/[^\d\.]/g, "");
            if (Number(paymentInfoForm["payment_amount"]) > Number(unpaid_amount)) {
                paymentInfoForm["payment_amount"] = unpaid_amount;
            }
            if (paymentInfoForm["payment_amount"]) {
                let amount = Math.abs(parseFloat(paymentInfoForm["payment_amount"]));
                const some = unpaid_amount.toString().split(".")[1].length;
                const parts = amount.toFixed(some).split(".");
                const integerPart = parts[0];
                const decimalPart = some > 0 ? (parts[1] ? parts[1] : "0".repeat(some)) : "";
                // 拼接成完整的金额格式
                paymentInfoForm["payment_amount"] = some > 0 ? `${integerPart}.${decimalPart}` : integerPart;
            }
        },
        // 选择时间
        handleClickSelectPayTime() {
            this.showDatePopupShow = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.showDatePopupShow = false;
            this.paymentInfoForm.payment_time = this.formatDate(date, "datetime");
        },
        formatDate(dateString, date_type) {
            // 创建日期对象
            const dateObj = new Date(dateString);
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            const hours = ("0" + dateObj.getHours()).slice(-2);
            const minutes = ("0" + dateObj.getMinutes()).slice(-2);
            const seconds = ("0" + dateObj.getSeconds()).slice(-2);
            let formattedDateTime = "";
            if (date_type === "date") {
                formattedDateTime = year + "-" + month + "-" + day;
            } else if (date_type === "year-month") {
                formattedDateTime = year + "-" + month;
            } else if (date_type === "datetime") {
                formattedDateTime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            }
            return formattedDateTime;
        },
        // 上传图片
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024)) return that.$toast("图片大小不允许超过5m");
                if (that.paymentInfoForm.voucher.length + files.length > 5) return that.$toast("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.paymentInfoForm.voucher.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        // 预览图片
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        handleClickConfirm() {
            this.$refs.payablePaymentForm.validate().then(() => {
                let params = {
                    payment_method: this.paymentInfoForm.payment_method,
                    payment_time: this.paymentInfoForm.payment_time,
                    remarks: this.paymentInfoForm.remarks,
                    voucher: this.paymentInfoForm.voucher,
                };
                if (this.paymentType === "payment") {
                    // 单个付款
                    this.formLoading = true;
                    this.btnDisabled = true;
                    params.payable_no = this.payable_no;
                    params.payment_amount = this.paymentInfoForm.payment_amount;
                    PayablePaymentAdd(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$router.go(-1);
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$toast(res.message);
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                } else {
                    // 批量付款
                    const isValid = this.paymentInfoForm.payableBatchPayInfo.every((item) => item.payment_amount);
                    if (!isValid) return this.$toast("请校验所有的应付单支付金额是否填写完整");
                    this.formLoading = true;
                    this.btnDisabled = true;
                    let payables = this.paymentInfoForm.payableBatchPayInfo.map((item) => {
                        return {
                            payable_no: item.payable_no,
                            payment_amount: item.payment_amount,
                        };
                    });
                    params.payables = payables;
                    PayableBatchPayment(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$router.go(-1);
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$toast(res.message);
                            }
                        })
                        .catch((res) => {
                            this.$toast(res.message);
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.payable_payment_wrap {
    .mobile_container {
        .form_module_title {
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #333333;
            padding: 10px 16px 10px 28px;
            position: relative;

            &::before {
                content: "";
                width: 4px;
                height: 22px;
                opacity: 1;
                border-radius: 20px;
                background: #2990ff;
                position: absolute;
                left: 16px;
            }
        }

        .payable_list_item {
            width: 100%;
            padding: 10px 16px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 10px;

            .payable_list_item_top {
                padding-bottom: 8px;
                display: flex;
                align-items: center;
                position: relative;

                .mobile_head_user {
                    font-size: 0;
                    display: flex;
                    align-items: center;
                    background: #edf0f4;
                    border-radius: 22px;
                    margin-right: 8px;

                    img {
                        width: 22px;
                        min-width: 22px;
                        height: 22px;
                        border-radius: 50%;
                    }

                    span {
                        flex: 1;
                        font-size: 14px;
                        color: rgb(51, 51, 51);
                        font-weight: bold;
                        display: inline-block;
                        padding: 0 8px;
                        box-sizing: border-box;
                        max-width: 78px;
                    }
                }

                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }

                .link-label {
                    color: rgba(41, 144, 255, 1);
                }

                .payable_list_item_delete {
                    position: absolute;
                    right: 0;
                }
            }

            .payable_list_item_content {
                p {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);

                    & + p {
                        margin-top: 8px;
                    }

                    .link-label {
                        color: rgba(41, 144, 255, 1);
                    }
                }

                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);
                    margin-top: 8px;

                    & > div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }

                    & > div + div {
                        margin-top: 4px;
                    }

                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }

                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }

                    .percent_bg2 {
                        background-color: rgba(41, 144, 255, 0.08);
                        padding-right: 0;
                    }

                    .percent_bg3 {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                }
            }

            .van-cell {
                padding: 11px 0 0 7px;
                font-size: 14px;
                line-height: 22px;
                // ::v-deep .van-field__label {
                //     span {
                //         color: rgba(228, 65, 68, 1);
                //     }
                // }

                &::before {
                    left: 0;
                }
            }
        }
    }

    .add_footer_wrap {
        padding: 5px 16px;
        background-color: rgba(247, 248, 250, 1);

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }

    .paylog_wrap {
        margin-bottom: 20px;
        padding: 10px 16px;
        background: rgba(255, 255, 255, 1);

        li {
            border-radius: 6px;
            background: rgba(249, 249, 249, 1);
            padding: 8px 10px 2px;
            margin-bottom: 10px;

            p {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 8px;
            }

            .voucher_list {
                margin-top: 4px;
                display: flex;
                gap: 8px;

                .voucher_item {
                    width: 48px;
                    height: 48px;
                    cursor: pointer;
                    position: relative;
                    text-align: center;
                    line-height: 48px;
                    border-radius: 4px;

                    .van-image {
                        max-width: 100%;
                        max-height: 100%;
                    }

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}

.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
